import React, { ReactNode, useState } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import { CustomDropdown } from 'src/components/CustomDropdown'
import useWidth from 'src/hooks/useWidth'
import { Tab } from './Components'
import styles from './styles.module.scss'

type Props = {
  className?: string
  data: {
    content: ReactNode
    icon: ReactNode
    id: string
    title: ReactNode
    desktopOnly?: boolean
    hideOnMobile?: boolean
  }[]
  initialTab?: string
}

export const Tabs = ({ initialTab, data, className }: Props) => {
  const { isMobile } = useWidth()
  const [isOpen, setIsOpen] = useState(false)
  const [tabActive, setTabActive] = useState(() => {
    return data.find(tab => tab.id === initialTab)?.id || data[0].id
  })

  const handleChange = id => {
    setTabActive(id)
    setIsOpen(false)
  }

  const currentTab = data.find(tab => tab.id === tabActive)
  const tabContent = currentTab?.content

  return isMobile ? (
    <div className={clsx(styles.contentTabs, className)}>
      <div className={styles.dropdownContainer}>
        <CustomDropdown
          customTitle={currentTab.title}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          showArrow
          titleValue={currentTab.title}
        >
          {data
            .filter(tab => (isMobile ? !tab.hideOnMobile : tab))
            .map(tab => {
              const isChecked = tab.id === tabActive
              return (
                !tab.desktopOnly && (
                  <div
                    key={tab.id}
                    className={styles.item}
                    onClick={() => handleChange(tab.id)}
                  >
                    {isChecked && (
                      <Image
                        src='/assets/icons/icon-check.svg'
                        width='16'
                        height='16'
                        alt='Check icon'
                      />
                    )}
                    {tab.title}
                  </div>
                )
              )
            })}
        </CustomDropdown>
      </div>
      <div>{tabContent}</div>
    </div>
  ) : (
    <div className={clsx(styles.contentTabs, className)}>
      <div className={styles.tabs}>
        {data.map(tab => (
          <Tab
            {...tab}
            active={tab.id === tabActive}
            key={tab.id}
            onSelect={handleChange}
          />
        ))}
      </div>
      <div>{tabContent}</div>
    </div>
  )
}

export default Tabs
